import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { XButton } from "../button/x-button";
type ExportExcelDialogProps = DialogProps & {
  handleClose?: () => void;
  exportHandler?: () => Promise<void>;
  exportBtnDisabled?: boolean;
};
export const ExportExcelDialog = ({
  handleClose,
  exportHandler,
  exportBtnDisabled,
  ...props
}: ExportExcelDialogProps) => {
  const { setProp } = useStores();
  const exportBtnClickHandler = useCallback(async () => {
    try {
      setProp("inProgress", true);
      await exportHandler?.();
    } catch (error) {
      console.error("Error during export:", error);
    } finally {
      setProp("inProgress", false);
    }
  }, [exportHandler, setProp]);
  return (
    <Dialog fullWidth maxWidth="sm" {...props}>
      <DialogTitle>Xuất excel</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        <XButton autoFocus onClick={handleClose}>
          Đóng
        </XButton>
        <XButton
          variant="contained"
          onClick={exportBtnClickHandler}
          disabled={exportBtnDisabled}
        >
          Xuất excel
        </XButton>
      </DialogActions>
    </Dialog>
  );
};
